import api from './api';
import { GetOrdersParams, GetOrdersResponse, Order } from '@/types/order';

export const vendorOrderApi = {
    async getOrders(params?: GetOrdersParams): Promise<GetOrdersResponse> {
        try {
            const response = await api.get('/vendor/orders', { params });
            return response.data;
        } catch (error: any) {
            console.error('Error fetching vendor orders:', error);
            throw new Error(error.response?.data?.error || 'Siparişler yüklenemedi');
        }
    },

    async getOrderById(id: string): Promise<Order> {
        try {
            const response = await api.get(`/vendor/orders/${id}`);
            return response.data;
        } catch (error: any) {
            console.error('Error fetching vendor order:', error);
            throw new Error(error.response?.data?.error || 'Sipariş yüklenemedi');
        }
    },

    async updateOrderStatus(id: string, status: string): Promise<Order> {
        try {
            const response = await api.put(`/vendor/orders/${id}/status`, { status });
            return response.data;
        } catch (error: any) {
            console.error('Error updating vendor order status:', error);
            throw new Error(error.response?.data?.error || 'Durum güncellenemedi');
        }
    },

    async uploadOrderPreview(id: string, photoUrl: string): Promise<Order> {
        try {
            const response = await api.post(`/vendor/orders/${id}/preview`, { photoUrl });
            return response.data;
        } catch (error: any) {
            console.error('Error uploading vendor order preview:', error);
            throw new Error(error.response?.data?.error || 'Önizleme güncellenemedi');
        }
    },

    async approveOrderPreview(id: string): Promise<Order> {
        try {
            const response = await api.post(`/vendor/orders/${id}/approve-preview`);
            return response.data;
        } catch (error: any) {
            console.error('Error approving order preview:', error);
            throw new Error(error.response?.data?.error || 'Görsel onaylanamadı');
        }
    },

    async assignCourier(orderId: string, courierId: string): Promise<Order> {
        try {
            const response = await api.put(`/vendor/orders/${orderId}/assign-courier`, { courierId });
            return response.data;
        } catch (error: any) {
            console.error('Error assigning vendor courier:', error);
            throw new Error(error.response?.data?.error || 'Kurye atanamadı');
        }
    },

    async assignCourierWithFee(orderId: string, courierId: string, courierFee?: number): Promise<Order> {
        try {
            const response = await api.put(`/vendor/orders/${orderId}/assign-courier`, { courierId, courierFee });
            return response.data;
        } catch (error: any) {
            console.error('Error assigning vendor courier with fee:', error);
            throw new Error(error.response?.data?.error || 'Kurye atanamadı');
        }
    },

    async markPaymentProcessed(id: string): Promise<Order> {
        try {
            const response = await api.put(`/vendor/orders/${id}/payment-processed`);
            return response.data;
        } catch (error: any) {
            console.error('Error marking vendor payment processed:', error);
            throw new Error(error.response?.data?.error || 'Ödeme işlenemedi');
        }
    },
};